export function currentPath () { return window.location.pathname; }

function scrollToSmooth(x: number, y: number): void { // AI port
    // Note: this is supported natively in Chrome and Firefox, but to work in safari the smoothscroll script or some
    // equivalent must be loaded prior to using behavior smooth.  See browser/load-and-initialize-smoothscroll-polyfill
    try { window.scrollTo({ left: x, top: y, behavior: "smooth", }); }
    catch (e) {}
}

function findYPos(obj: HTMLElement): number { // AI port
    let currentObj: HTMLElement | null = obj;
    let offset = 0;
    while (currentObj) { // Loop while there's an offsetParent (i.e., not at the top of the document's layout tree)
        offset += currentObj.offsetTop;
        currentObj = currentObj.offsetParent as HTMLElement | null; // Cast to HTMLElement | null
    }
    return offset;
}

/**
 * Scrolls to the given element but smoothly instead of abruptly
 */
export function scrollToElementSmooth(el: HTMLElement): void;
export function scrollToElementSmooth(el: HTMLElement, offset: number): void;
export function scrollToElementSmooth(el: HTMLElement, offset: number = 0): void { // AI port
    const y = findYPos(el) - offset;
    scrollToSmooth(0, y);
}

export function scrollToIdSmooth(id: string): void { // AI port
    let element = document.getElementById(id);
    element && scrollToElementSmooth(element);
}
